import { MetaDataProperties } from 'asset-actions-lib-forms/constants/form';
import { getIsExternalEditorCOS } from 'asset-actions-lib-forms/utils/urlUtils';
import useGetFormMetadata from './useGetFormMetadata';

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/1272b073b4a501e516ed83ba8d9c2fcee528c188/FormsUI/static/js/selectors/FormDefinition.js#L525
 */
export default function useIsRenderRawHtmlEnabled(formGuid) {
  const getFormMetadata = useGetFormMetadata(formGuid);
  const isRenderRawHtmlEnabled = getFormMetadata(MetaDataProperties.IS_RENDER_RAW_HTML_ENABLED);
  const isExternalEditor = getIsExternalEditorCOS();
  return isExternalEditor || isRenderRawHtmlEnabled === 'true';
}